export const getterSetterDeliveryOptionValue = (paramName) => {
    return {
        get() {
            return this.coStore.deliveryOptions[paramName];
        },

        set(value) {
            this.setDeliveryOption({ option: paramName, value })
        }
    }
};
